export default function MetricsCards({ metrics }) {
  return metrics.map((m, i) => (
    <div className="col h-100" key={i}>
      <div className="card h-100">
        <div className="card-body">
          <h6 className="text-start text-secondary mb-2">
            {m.label}
          </h6>
          <p className="display-5 fw-semibold text-start mb-0 text-nowrap">
            {m.value}
          </p>
        </div>
      </div>
    </div>
  ));
}
